angular.module('unergie.main')
.controller('newVersionModalCtrl', ($scope, $timeout, $uibModalInstance, text, showButtons, ErrorCatcher) => {
    $scope.text = text
    $scope.showButtons = showButtons
    $scope.close = $uibModalInstance.dismiss
    $scope.ok = $uibModalInstance.close
})
